export class User {
  id: number;
  name: string;
  email: string;
  password: string;
  phone_number: string;
  id_empresa: number;
  rastrear_posicion: boolean;
}
